import API from "@/API";

export const getDBSCyclePortInfoFromMixway = async () => {
    var corporation = window.prompt(
      "Docomoなら'd' or HelloCyclingなら'h'を入力"
    );
    let info;
    if (corporation == "d") {
      // 新宿区役所第二分庁舎／ドコモ・バイクシェア
      info = await API.getDbsCyclePorts("35.693976,139.706134");
    } else {
      // VORT東新宿／HELLO CYCLING
      info = await API.getDbsCyclePorts("35.7031851,139.7086939,500");
    }
    // NativeからWebviewへ情報を渡すフローをふむ
    await window.jcSetDbsShareInfo(info);
};
